import EFPicture from 'elem/compCommon/EFPicture';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getSolarRecommand } from '@/service/solar-calculator';

export default function D() {
    const { useLang, useState, useEffect, useRouter, Link } = useGlobal();
    const { t } = useLang('refurbished');
    const { locale } = useRouter();

    const cards: any = [
        {
            img: '/responsive/picture/common-products/deltapro.png',
            power: t('secD_card1_power'),
            title: t('secD_card1_title'),
            desc: t('secD_card1_desc'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-pro-portable-power-station-refurbished',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6674181128265',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40563656523849',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '/responsive/picture/common-products/wave2.png',
            power: t('secD_card2_power'),
            title: t('secD_card2_title'),
            desc: t('secD_card2_desc'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/ecoflow-wave-2-portable-air-conditioner-refurbished',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6911361843273',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40560673980489',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '/responsive/picture/common-products/400w.png',
            power: t('secD_card3_power'),
            title: t('secD_card3_title'),
            desc: t('secD_card3_desc'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/400w-portable-solar-panel-refurbished',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6911390449737',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40560809279561',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
    ];

    const [cardLists, setCardLists] = useState(cards);

    useEffect(() => {
        const tempArr = [...cards];
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        tempArr[k].discountPrice = res?.data?.price;
                        tempArr[k].originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                        tempArr[k].inventory = res?.data?.inventoryQuantity ?? undefined;
                        tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${tempArr[k].variantId}:1?channel=buy_button`;
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };
        const promises = tempArr?.map((item: any, k: number) => getAsynItem(item?.productId, item.variantId, k));
        Promise.all(promises)
            .then(() => {
                setCardLists(tempArr?.filter((list: any) => list?.inventory !== undefined));
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    return (
        <div id="refurbished-D" className={`refurbished-D ${css['refurbished-D']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secD_title')}</p>
                </div>
                <ul className="cards">
                    {cardLists?.map((card: any, k: number) => (
                        <li className="card" key={k}>
                            <div className="card-img">
                                <EFPicture src={card?.img} alt={card.title} />
                            </div>
                            <div className="card-info">
                                <p className="card-power">{card?.power}</p>
                                <p className="card-title">{card?.title}</p>
                                <p className="card-desc">{card?.desc}</p>
                                <p className="card-price">{FormatMoneyLocal(card?.discountPrice, locale)}</p>
                                <Link
                                    className="card-buy"
                                    href={`${card?.link_more}${
                                        String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                    }utm_source=scenario+page&utm_medium=Pillar`}
                                >
                                    {t('secD_buy_now')}
                                </Link>
                            </div>
                        </li>
                    ))}
                </ul>
                <Link className="all-product" href={`https://us.ecoflow.com/pages/refurbished`}>
                    <span className="link-text">{t('secD_shop_all')}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M8.5 5.5L15 12L8.5 18.5" stroke="#3F68E0" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </Link>
            </div>
        </div>
    );
}
